import { initialValuesBank as initialValues } from '../../../../../../helpers/variablesInitialValues';
import * as types from '../types/bankType';

const initialState = {
	perPage: 10,
	page: 1,
	pages: 1,
	search: '',
	arrayList: [],
	arrayListToDropdown: [],
	refreshTable: false,
	isOpenModal: false,
	isOpenModalPermission: false,
	isLoadingShow: false,
	isLoadingForm: false,
	formType: '',
	formData: initialValues
};

const bankReducer = (state = initialState, { type, payload }) => {
	switch (type) {
		case types.PER_PAGE_BANK:
			return {
				...state,
				perPage: payload
			};
		
		case types.PAGE_BANK:
			return {
				...state,
				page: payload
			};
		
		case types.PAGES_BANK:
			return {
				...state,
				pages: payload
			};
		
		case types.SEARCH_BANK:
			return {
				...state,
				search: payload
			};
		
		case types.ARRAY_LIST_BANK:
			return {
				...state,
				arrayList: payload
			};
		
		case types.ARRAY_LIST_TO_DROPDOWN_BANK:
			return {
				...state,
				arrayListToDropdown: payload
			};
		
		case types.REFRESH_TABLE_BANK:
			return {
				...state,
				refreshTable: payload
			};
		
		case types.IS_OPEN_MODAL_BANK:
			return {
				...state,
				isOpenModal: payload
			};
		
		case types.IS_LOADING_SHOW_BANK:
			return {
				...state,
				isLoadingShow: payload
			};
		
		case types.IS_LOADING_FORM_BANK:
			return {
				...state,
				isLoadingForm: payload
			};
		
		case types.FORM_TYPE_BANK:
			return {
				...state,
				formType: payload
			};
		
		case types.FORM_DATA_BANK:
			return {
				...state,
				formData: payload
			};
		
		default:
			return state
	}
};

export default bankReducer;
